<template>
  <RemotePaginatedList full-height
                       hide-search
                       :headers="headers"
                       data-url="aafb/admin/report/"
                       data-key="reports"
                       :extra-filters="{'type': [type]}"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.content="{value}">
      <v-tooltip top
                 v-if="value">
        <template #activator="{on, attrs}">
          <a :href="'api/static/'+value"
             target="_blank">
            <v-btn icon
                   v-on="on"
                   v-bind="attrs">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </a>
        </template>
        <span>Download</span>
      </v-tooltip>
    </template>
  </RemotePaginatedList>
</template>
<script>
import RemotePaginatedList from "@/components/RemotePaginatedList.vue";
import {ref} from "@vue/composition-api";

export default {
  name: 'ReportList',
  props: {
    type: String,
  },
  components: {RemotePaginatedList},
  setup(props, {root}) {
    const headers = ref([
      {text: 'Date', value: 'title'},
      {text: '', value: 'content'},
    ]);
    const innerRefreshTrigger = ref(false);

    return {
      headers,
      innerRefreshTrigger,
    }
  },
}
</script>
